import React, { useState, useEffect } from 'react';
import { useGlobal } from 'context/global/GlobalContext';
import { VideoModuleType } from 'types/ProductDetailsType';
import ModuleWrapper from 'components/wrappers/ModuleWrapper';

type VideoDrawerProps = {
  drawerTitle: string;
  closeDrawer: () => void;
  drawerData?: VideoModuleType;
};

const VideoDrawer: React.FC<VideoDrawerProps> = ({
  drawerData,
  drawerTitle,
  closeDrawer,
}) => {
  const [showControls, toggleControls] = useState<boolean>(false);
  const { desktopView } = useGlobal();

  useEffect(() => {
    if (!desktopView) closeDrawer();
  }, [closeDrawer, desktopView]);

  return desktopView ? (
    <ModuleWrapper drawerTitle={drawerTitle}>
      <div className='relative flex items-start pt-3 aspect-video'>
        {drawerData?.path && (
          <video
            controls={showControls}
            onMouseEnter={() => toggleControls(true)}
          >
            <source
              src={drawerData.path}
              type={
                drawerData.path.includes('.mp4') ? 'video/mp4' : 'video/webm'
              }
            />
          </video>
        )}
      </div>
    </ModuleWrapper>
  ) : (
    <div className='w-full h-full flex' />
  );
};

export default VideoDrawer;
